import { render } from "./memberPayments.vue?vue&type=template&id=076081e4&scoped=true"
import script from "./memberPayments.vue?vue&type=script&lang=js"
export * from "./memberPayments.vue?vue&type=script&lang=js"

import "./memberPayments.vue?vue&type=style&index=0&id=076081e4&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/twiga_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076081e4"]])

export default __exports__